
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface PetsHeaderProps {
  onAddPet: () => void;
}

const PetsHeader: React.FC<PetsHeaderProps> = ({ onAddPet }) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-8 gap-4">
      <div>
        <h1 className="text-3xl font-display font-bold">Your Pets</h1>
        <p className="text-gray-600">Manage and organize your pet profiles</p>
      </div>
      
      <Button 
        onClick={onAddPet} 
        className="btn-primary"
      >
        <Plus size={18} className="mr-2" />
        Add Pet
      </Button>
    </div>
  );
};

export default PetsHeader;
